export const ELIGIBILITY_BY_STORES_FACET = 'eligibilityByStores';
